import { getSavedAlbumsLayout } from "../reducers/albumListState";
import { getActionForResumingRandomMode, getActionForStartingRandomMode, getAlwaysClearQueue, getAutoNewRandomAlbum, getDetailedAlbumListPageSize, getRandomMethod, getRandomQueueLimit, getSquaredAlbumListPageSize } from "../reducers/userSettings";
import { loadActionForResumingRandomMode, loadActionForStartingRandomMode, loadDetailedAlbumListPageSize, loadAlwaysClearQueue, loadAutoNewRandomAlbum, loadRandomMethod, loadRandomQueueLimit, saveActionForResumingRandomMode, saveActionForStartingRandomMode, saveDetailedAlbumListPageSize, saveAlwaysClearQueue, saveAutoNewRandomAlbum, saveRandomMethod, saveRandomQueueLimit, saveSquaredAlbumListPageSize, loadSquaredAlbumListPageSize } from "../utils/localStorageUtils";
import { ALBUM_LAYOUTS } from "../utils/constants/enumConstants";

export const SET_CURRENT_ALBUM_LIST_PAGE_SIZE = 'SET_CURRENT_ALBUM_LIST_PAGE_SIZE';
export const SET_DETAILED_ALBUM_LIST_PAGE_SIZE = 'SET_DETAILED_ALBUM_LIST_PAGE_SIZE';
export const SET_SQUARED_ALBUM_LIST_PAGE_SIZE = 'SET_SQUARED_ALBUM_LIST_PAGE_SIZE';
export const SET_RANDOM_METHOD = 'SET_RANDOM_METHOD';
export const SET_RANDOM_QUEUE_LIMIT = 'SET_RANDOM_QUEUE_LIMIT';
export const SET_AUTO_NEW_RANDOM_ALBUM = 'SET_AUTO_NEW_RANDOM_ALBUM';
export const SET_ALWAYS_CLEAR_QUEUE = 'SET_ALWAYS_CLEAR_QUEUE';
export const SET_ACTION_FOR_STARTING_RANDOM_MODE = 'SET_ACTION_FOR_STARTING_RANDOM_MODE';
export const SET_ACTION_FOR_RESUMING_RANDOM_MODE = 'SET_ACTION_FOR_RESUMING_RANDOM_MODE';
export const SET_SETTINGS_WINDOW_VISIBLE = 'SET_SETTINGS_WINDOW_VISIBLE';

export const setCurrentAlbumListPageSize = () => {
    return (dispatch, getState) => {
        const state = getState();
        const layout = getSavedAlbumsLayout(state);
        const detailedAlbumSize = getDetailedAlbumListPageSize(state);
        const squaredAlbumSize = getSquaredAlbumListPageSize(state);

        if(layout === ALBUM_LAYOUTS.list) dispatch({type: SET_CURRENT_ALBUM_LIST_PAGE_SIZE, payload: detailedAlbumSize});
        if(layout === ALBUM_LAYOUTS.grid) dispatch({type: SET_CURRENT_ALBUM_LIST_PAGE_SIZE, payload: squaredAlbumSize});
    }
}

export const setDetailedAlbumListPageSize = value => {
    return dispatch => {
        saveDetailedAlbumListPageSize(value);
        dispatch({type: SET_DETAILED_ALBUM_LIST_PAGE_SIZE, payload: value});
        dispatch(setCurrentAlbumListPageSize());
    }
}

export const setSquaredAlbumListPageSize = value => {
    return dispatch => {
        saveSquaredAlbumListPageSize(value);
        dispatch({type: SET_SQUARED_ALBUM_LIST_PAGE_SIZE, payload: value});
        dispatch(setCurrentAlbumListPageSize());
    }
}

export const setRandomMethod = value => {
    return dispatch => {
        saveRandomMethod(value);
        dispatch({type: SET_RANDOM_METHOD, payload: value});
    }
}

export const setRandomQueueLimit = value => {
    return dispatch => {
        saveRandomQueueLimit(value);
        dispatch({type: SET_RANDOM_QUEUE_LIMIT, payload: value});
    }
}

export const setAutoNewRandomAlbum = value => {
    return dispatch => {
        saveAutoNewRandomAlbum(value);
        dispatch({type: SET_AUTO_NEW_RANDOM_ALBUM, payload: value});
    }
}

export const setAlwaysClearQueue = value => {
    return dispatch => {
        saveAlwaysClearQueue(value);
        dispatch({type: SET_ALWAYS_CLEAR_QUEUE, payload: value});
    }
}

export const setActionForStartingRandomMode = value => {
    return dispatch => {
        saveActionForStartingRandomMode(value);
        dispatch({type: SET_ACTION_FOR_STARTING_RANDOM_MODE, payload: value});
    }
}

export const setActionForResumingRandomMode = value => {
    return dispatch => {
        saveActionForResumingRandomMode(value);
        dispatch({type: SET_ACTION_FOR_RESUMING_RANDOM_MODE, payload: value});
    }
}

export const setSettingsWindowVisible = payload => ({type: SET_SETTINGS_WINDOW_VISIBLE, payload});

export const initUserSettings = () => {
    const initDetailedAlbumListPageSize = (dispatch, state) => {
        const savedDetailedAlbumListPageSize = loadDetailedAlbumListPageSize();
        if(savedDetailedAlbumListPageSize === null)
        {
            const defaultDetailedAlbumListPageSize = getDetailedAlbumListPageSize(state);
            dispatch(setDetailedAlbumListPageSize(parseInt(defaultDetailedAlbumListPageSize)));
        }
        else
        {
            dispatch(setDetailedAlbumListPageSize(parseInt(savedDetailedAlbumListPageSize)));
        }
    }

    const initSquaredAlbumListPageSize = (dispatch, state) => {
        const savedSquaredAlbumListPageSize = loadSquaredAlbumListPageSize();
        if(savedSquaredAlbumListPageSize === null)
        {
            const defaultSquaredAlbumListPageSize = getSquaredAlbumListPageSize(state);
            dispatch(setSquaredAlbumListPageSize(parseInt(defaultSquaredAlbumListPageSize)));
        }
        else
        {
            dispatch(setSquaredAlbumListPageSize(parseInt(savedSquaredAlbumListPageSize)));
        }
    }

    const initRandomMethod = (dispatch, state) => {
        const savedRandomMethod = loadRandomMethod();
        if(savedRandomMethod === null)
        {
            const defaultRandomMethod = getRandomMethod(state);
            saveRandomMethod(defaultRandomMethod);
        }
        else
        {
            dispatch(setRandomMethod(savedRandomMethod));
        }
    }

    const initRandomQueueLimit = (dispatch, state) => {
        const savedRandomQueueLimit = loadRandomQueueLimit();
        if(savedRandomQueueLimit === null)
        {
            const defaultRandomQueueLimit = getRandomQueueLimit(state);
            saveRandomQueueLimit(defaultRandomQueueLimit);
        }
        else
        {
            dispatch(setRandomQueueLimit(parseInt(savedRandomQueueLimit)));
        }
    }

    const initAutoNewRandomAlbum = (dispatch, state) => {
        const savedAutoNewRandomAlbum = loadAutoNewRandomAlbum();
        if(savedAutoNewRandomAlbum === null)
        {
            const defaultAutoNewRandomAlbum = getAutoNewRandomAlbum(state);
            saveAutoNewRandomAlbum(defaultAutoNewRandomAlbum);
        }
        else
        {
            dispatch(setAutoNewRandomAlbum(savedAutoNewRandomAlbum));
        }
    }

    const initAlwaysClearQueue = (dispatch, state) => {
        const savedAlwaysClearQueue = loadAlwaysClearQueue();

        if(savedAlwaysClearQueue === null)
        {
            const defaultAlwaysClearQueue = getAlwaysClearQueue(state);
            saveAlwaysClearQueue(defaultAlwaysClearQueue);
        }
        else
        {
            dispatch(setAlwaysClearQueue(savedAlwaysClearQueue));
        }
    }

    const initActionForStartingRandomMode = (dispatch, state) => {
        const savedActionForStartingRandomMode = loadActionForStartingRandomMode();
        if(savedActionForStartingRandomMode === null)
        {
            const defaultActionForStartingRandomMode = getActionForStartingRandomMode(state);
            saveActionForStartingRandomMode(defaultActionForStartingRandomMode);
        }
        else
        {
            dispatch(setActionForStartingRandomMode(savedActionForStartingRandomMode));
        }
    }

    const initActionForResumingRandomMode = (dispatch, state) => {
        const savedActionForResumingRandomMode = loadActionForResumingRandomMode();
        if(savedActionForResumingRandomMode === null)
        {
            const defaultActionForResumingRandomMode = getActionForResumingRandomMode(state);
            saveActionForResumingRandomMode(defaultActionForResumingRandomMode);
        }
        else
        {
            dispatch(setActionForResumingRandomMode(savedActionForResumingRandomMode));
        }
    }

    return (dispatch, getState) => {
        const state = getState();

        initDetailedAlbumListPageSize(dispatch, state);
        initSquaredAlbumListPageSize(dispatch, state);
        initRandomMethod(dispatch, state);
        initRandomQueueLimit(dispatch, state);
        initAutoNewRandomAlbum(dispatch, state);
        initAlwaysClearQueue(dispatch, state);
        initActionForStartingRandomMode(dispatch, state);
        initActionForResumingRandomMode(dispatch, state);
    }
}

export const saveUserSettings = (settings) => {
    return dispatch => {
        if(settings.detailedAlbumListPageSize !== undefined)
        {
            dispatch(setDetailedAlbumListPageSize(parseInt(settings.detailedAlbumListPageSize)));
        }

        if(settings.squaredAlbumListPageSize !== undefined)
        {
            dispatch(setSquaredAlbumListPageSize(parseInt(settings.squaredAlbumListPageSize)));
        }

        if(settings.randomMethod !== undefined)
        {
            dispatch(setRandomMethod(settings.randomMethod));
        }

        if(settings.randomQueueLimit !== undefined)
        {
            dispatch(setRandomQueueLimit(parseInt(settings.randomQueueLimit)));
        }

        if(settings.autoNewRandomAlbum !== undefined)
        {
            dispatch(setAutoNewRandomAlbum(settings.autoNewRandomAlbum));
        }

        if(settings.alwaysClearQueue !== undefined)
        {
            dispatch(setAlwaysClearQueue(settings.alwaysClearQueue));
        }

        if(settings.actionForStartingRandomMode !== undefined)
        {
            dispatch(setActionForStartingRandomMode(settings.actionForStartingRandomMode));
        }

        if(settings.actionForResumingRandomMode !== undefined)
        {
            dispatch(setActionForResumingRandomMode(settings.actionForResumingRandomMode));
        }
    }
}